import { FieldDateRange } from '@/components/looker/field-date-range';
import { getLocalTimezoneAbbreviation } from '@/components/pages/assets/capacity-test/utils';
import { useNow } from '@/hooks/useNow';

import type { DateRange, DateRangeFilterProps } from './types';
import { clampDateRange } from './utils';

export function DateRangeFilterBase({ value, onChange }: DateRangeFilterProps) {
  const now = useNow();

  function handleChange(nextValue: DateRange) {
    onChange(clampDateRange(nextValue, now));
  }

  const timezone = getLocalTimezoneAbbreviation(now);

  return (
    <div data-testid="system-logs-date-range-filter">
      <FieldDateRange
        label={`Time Window (${timezone})`}
        value={value}
        onChange={handleChange}
        dateStringFormat="yyyy/MM/dd"
      />
    </div>
  );
}
